import { adminRoles } from '@/constants';
import { checkAndRedirectForOrgAdminAccess, getSelectedOrg } from '@/helpers';
import { fetchInstruments } from '@/services/instruments';
import { useAppStore } from '@/stores/app';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/instruments/')({
  beforeLoad: ({ context, location }) => {
    const store = useAppStore.getState();
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;

    checkAndRedirectForOrgAdminAccess({
      context,
      location,
      selectedOrganization,
      adminRoles,
      redirect,
    });
  },
  loader: async () => {
    const selectedOrg = getSelectedOrg();
    if (!selectedOrg?.id) return [];
    return fetchInstruments(selectedOrg.id);
  },
});
